// import React from 'react';
// import PageHeader from '../components/PageHeader';
// import './Update.css';

// const updates = [
//   {
//     emoji: '🌾',
//     date: 'March 2026',
//     title: 'Ajera Export Expands to Southeast Asia',
//     desc: 'Ajera Export has successfully entered new markets in Malaysia, Thailand, and Indonesia with premium agro commodities.',
//     gradient: 'linear-gradient(135deg, #1e3a8a, #3b82f6)',
//   },
//   {
//     emoji: '💻',
//     date: 'February 2026',
//     title: 'Ajera Infotech Launches New Enterprise Platform',
//     desc: 'Our latest enterprise SaaS platform is now live, offering end-to-end digital transformation for mid-market businesses.',
//     gradient: 'linear-gradient(135deg, #1d4ed8, #06b6d4)',
//   },
//   {
//     emoji: '🏗️',
//     date: 'January 2026',
//     title: 'Ajera Builttech Wins Infrastructure Contract',
//     desc: 'Ajera Builttech has been awarded a major infrastructure development project worth ₹120 crore in Tamil Nadu.',
//     gradient: 'linear-gradient(135deg, #0f766e, #3b82f6)',
//   },
//   {
//     emoji: '🏆',
//     date: 'December 2025',
//     title: 'Ajera Group Recognized as Top Emerging Enterprise',
//     desc: "Ajera Group has been recognized as one of India's top emerging multi-industry enterprises by a leading business magazine.",
//     gradient: 'linear-gradient(135deg, #7c3aed, #2563eb)',
//   },
//   {
//     emoji: '🤝',
//     date: 'November 2025',
//     title: 'Strategic Partnership with Global Logistics Firm',
//     desc: 'Ajera Export has signed a strategic partnership agreement with a global logistics firm to enhance supply chain efficiency.',
//     gradient: 'linear-gradient(135deg, #b45309, #d97706)',
//   },
//   {
//     emoji: '🌱',
//     date: 'October 2025',
//     title: 'Sustainability Initiative Launched',
//     desc: 'Ajera Group launches its 2030 sustainability roadmap focusing on carbon neutrality and responsible sourcing across all units.',
//     gradient: 'linear-gradient(135deg, #15803d, #22c55e)',
//   },
// ];

// const Update: React.FC = () => {
//   return (
//     <>
//       <PageHeader
//         breadcrumb="Update"
//         title="Latest Updates"
//         subtitle="News, announcements, and insights from Ajera Group."
//       />
//       <div className="update-grid">
//         {updates.map((u) => (
//           <div className="update-card" key={u.title}>
//             <div className="update-card-img" style={{ background: u.gradient }}>
//               <span>{u.emoji}</span>
//             </div>
//             <div className="update-card-body">
//               <div className="update-date">{u.date}</div>
//               <h3>{u.title}</h3>
//               <p>{u.desc}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default Update;


import React from 'react';
import PageHeader from '../components/PageHeader';
import './Update.css';

interface UpdateItem {
  id: string;
  image: string;   // path to PNG in /public/assets/updates/
  date: string;
  title: string;
  desc: string;
}

const updates: UpdateItem[] = [
  {
    id: 'moringa-fresh',
    image: '/Fresh Moringa Leaves.jpg',
    date: 'March 2026',
    title: 'AJERA Agro Export – Fresh Moringa Leaves',
    desc: 'AJERA Agro Export continues to source premium-quality fresh moringa leaves directly from farms. Our focus remains on freshness, quality, and reliable supply for domestic and export markets.',
  },
  {
    id: 'moringa-dried',
    image: '/Dried Moringa Leaves.jpg',
    date: 'March 2026',
    title: 'AJERA Agro Export – Dried Moringa Leaves',
    desc: 'Our dried moringa leaves are processed under hygienic conditions to preserve their natural nutrients. We are committed to delivering export-quality products that meet international standards.',
  },
  {
    id: 'drumsticks',
    image: '/Drumsticks.jpg',
    date: 'February 2026',
    title: 'AJERA Agro Export – Drumsticks',
    desc: 'AJERA Agro Export supplies fresh and carefully selected drumsticks from trusted farms. We ensure quality harvesting and timely delivery to meet customer requirements.',
  },
  {
    id: 'erp-recycling',
    image: '/ERP Software for Recycling Companies.jpg',
    date: 'February 2026',
    title: 'AJERA Infotech – ERP Software for Recycling Companies',
    desc: 'AJERA Infotech provides customized ERP software designed for recycling companies. Our solutions help manage inventory, operations, production, and business performance efficiently.',
  },
  {
    id: 'website-design',
    image: '/Website Design Services.jpg',
    date: 'January 2026',
    title: 'AJERA Infotech – Website Design Services',
    desc: 'AJERA Infotech creates modern, responsive, and user-friendly websites for businesses of all sizes. We help organizations build a strong digital presence and reach more customers online.',
  },
  {
    id: 'it-civil-training',
    image: '/IT & Civil Training.webp',
    date: 'January 2026',
    title: 'AJERA Infotech – IT & Civil Training',
    desc: 'AJERA Infotech offers practical training programs for students in IT and Civil Engineering fields. Our courses focus on real-world skills, industry exposure, and career development.',
  },
  {
    id: 'moringa-powder',
    image: '/Moringa-Leaves-Powder-1.jpg',
    date: 'December 2025',
    title: 'AJERA Agro Export – Moringa Leaves Powder',
    desc: 'AJERA Agro Export produces high-quality moringa leaves powder using advanced drying and grinding techniques, ensuring maximum nutrient retention for health and wellness markets.',
  },
];

const Update: React.FC = () => {
  return (
    <>
      <PageHeader
        breadcrumb="Update"
        title="Latest Updates"
        subtitle="News, announcements, and insights from Ajera Group."
      />
      <div className="update-grid">
        {updates.map((u) => (
          <div className="update-card" key={u.id}>
            <div className="update-card-img">
              <img src={u.image} alt={u.title} loading="lazy" />
            </div>
            <div className="update-card-body">
              {/* <div className="update-date">{u.date}</div> */}
              <h3>{u.title}</h3>
              <p>{u.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Update;